var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownRedLightRedBgCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#F7D4D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.65884 10.6345C6.86072 10.4461 7.17711 10.457 7.36553 10.6588C8.02998 11.3686 8.72661 12.0786 9.5 12.6715V6.50005C9.5 6.2239 9.72386 6 10 6C10.2761 6 10.5 6.22428 10.5 6.50042V12.6715C11.2737 12.0783 11.9686 11.3701 12.6345 10.6588C12.8229 10.457 13.1393 10.4461 13.3412 10.6345C13.543 10.8229 13.5539 11.1394 13.3655 11.3412C12.6437 12.1142 11.898 12.8733 11.05 13.5094C10.7526 13.7324 10.3889 14 10 14C9.61106 14 9.24737 13.7324 8.95 13.5094C8.10706 12.8772 7.35388 12.1073 6.63447 11.3412C6.44606 11.1393 6.45697 10.8229 6.65884 10.6345Z",
    fill: "#F53D4C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownRedLightRedBgCircle);
export default __webpack_public_path__ + "static/media/arrowDownRedLightRedBgCircle.12d28d3981991d965a91e4785e91c156.svg";
export { ForwardRef as ReactComponent };